var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"min-height":"434px"},attrs:{"grid-list-xl":"","fluid":""}},[(!_vm.cargando)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"lg3":"","sm6":"","xs12":""}},[_c('mini-statistic',{attrs:{"icon":"mdi-archive","title":_vm.totalExpedientes.toLocaleString(),"sub-title":"Expedientes","color":"blue"}})],1),_c('v-flex',{attrs:{"lg3":"","sm6":"","xs12":""}},[_c('mini-statistic',{attrs:{"icon":"mdi-home-modern","title":_vm.estadisticasCatastro.inmuebles.toLocaleString(),"sub-title":"Inmuebles","color":"red"}})],1),_c('v-flex',{attrs:{"lg3":"","sm6":"","xs12":""}},[_c('mini-statistic',{attrs:{"icon":"mdi-human-greeting","title":_vm.estadisticasCatastro.participan.toLocaleString(),"sub-title":"Participan","color":"teal"}})],1),_c('v-flex',{attrs:{"lg3":"","sm6":"","xs12":""}},[_c('mini-statistic',{attrs:{"icon":"mdi-human-male-female","title":_vm.estadisticasCatastro.inmueblesConUsuarios.toLocaleString(),"sub-title":"Ocupados","color":"green"}})],1),_c('v-flex',{attrs:{"lg6":"","sm12":"","xs12":""}},[_c('v-widget',{attrs:{"title":"Expedientes - Estado"}},[_c('div',{attrs:{"slot":"widget-content"},slot:"widget-content"},[_c('e-chart',{attrs:{"path-option":[
              ['dataset.source', _vm.statusData],
              [
                'color',
                [
                  _vm.color.amber.base,
                  _vm.color.indigo.base,
                  _vm.color.pink.base,
                  _vm.color.green.base,
                  _vm.color.teal.base,
                  _vm.color.purple.base
                ]
              ],
              ['legend.orient', 'horizontal'],
              ['legend.y', 'bottom'],
              ['xAxis.show', false],
              ['yAxis.show', false],
              ['series[0].type', 'pie'],
              ['series[0].avoidLabelOverlap', true],
              ['series[0].radius', ['50%', '70%']]
            ],"height":"350px","width":"100%"}})],1)])],1),_c('v-flex',{attrs:{"lg6":"","sm12":"","xs12":""}},[_c('v-widget',{attrs:{"title":"Expedientes - Provincias"}},[_c('div',{attrs:{"slot":"widget-content"},slot:"widget-content"},[_c('e-chart',{attrs:{"path-option":[
              ['dataset.source', _vm.provinciasData],
              [
                'color',
                [
                  _vm.color.lightBlue.base,
                  _vm.color.indigo.base,
                  _vm.color.pink.base,
                  _vm.color.green.base,
                  _vm.color.cyan.base,
                  _vm.color.teal.base
                ]
              ],
              ['legend.orient', 'horizontal'],
              ['legend.y', 'bottom'],
              ['xAxis.show', false],
              ['yAxis.show', false],
              ['series[0].type', 'pie']
            ],"height":"350px","width":"100%"}})],1)])],1),_c('v-flex',{attrs:{"lg6":"","sm12":"","xs12":""}},[_c('list-documents',{attrs:{"documents":_vm.documentosData}})],1),_c('v-flex',{attrs:{"lg6":"","sm12":"","xs12":""}},[_c('v-widget',{attrs:{"title":"Inmuebles - Usos"}},[_c('div',{attrs:{"slot":"widget-content"},slot:"widget-content"},[_c('e-chart',{attrs:{"path-option":[
              ['dataset.source', _vm.usosData],
              [
                'color',
                [
                  _vm.color.amber.base,
                  _vm.color.grey.base,
                  _vm.color.pink.base,
                  _vm.color.green.base,
                  _vm.color.teal.base,
                  _vm.color.purple.base,
                  _vm.color.indigo.base
                ]
              ],
              ['legend.orient', 'horizontal'],
              ['legend.y', 'bottom'],
              ['xAxis.show', false],
              ['yAxis.show', false],
              ['series[0].type', 'pie'],
              ['series[0].avoidLabelOverlap', true],
              ['series[0].radius', ['50%', '70%']]
            ],"height":"350px","width":"100%"}})],1)])],1),_c('v-flex',{attrs:{"lg6":"","sm12":"","xs12":""}},[_c('v-widget',{attrs:{"title":"Inmuebles - Resumen"}},[_c('div',{attrs:{"slot":"widget-content"},slot:"widget-content"},[_c('div',{staticClass:"echarts"},[_c('IEcharts',{attrs:{"option":_vm.catastroResumen}})],1)])])],1)],1):_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('div',{staticStyle:{"width":"40vw","display":"flex","justify-content":"center","align-items":"center"}},[_c('div',{staticStyle:{"flex":"1 1 auto"}},[_c('v-img',{attrs:{"resizable":true,"src":require('@/assets/logo_loading.gif'),"height":"150%"}})],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }